import { html, LitElement } from "../vendor/lit-element/lit-element";
import { gsap } from "gsap";

class DiseaseGlass extends LitElement {
  async firstUpdated() {
    // Give the browser a chance to paint
    await new Promise((r) => setTimeout(r, 0));

    const tl = gsap
      .timeline()
      .to(this, {
        opacity: 1,
      })
      .play();
  }

  createRenderRoot() {
    return this;
  }

  render() {
    return html`<svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 395.3 317.78"
    >
      <defs>
        <style>
          .cls-1 {
            isolation: isolate;
          }
          .cls-2 {
            fill: #38a947;
          }
          .cls-3 {
            font-size: 33px;
            font-family: Barlow-ExtraBold, Barlow;
            font-weight: 800;
          }
          .cls-3,
          .cls-7,
          .cls-8 {
            fill: #fff;
          }
          .cls-4,
          .cls-8,
          .cls-9 {
            font-size: 20px;
          }
          .cls-4 {
            font-family: Barlow-Bold, Barlow;
            font-weight: 700;
          }
          .cls-5 {
            letter-spacing: -0.03em;
          }
          .cls-17,
          .cls-18,
          .cls-20,
          .cls-6 {
            fill: none;
          }
          .cls-6 {
            stroke: #fff;
            stroke-width: 7px;
          }
          .cls-17,
          .cls-18,
          .cls-6 {
            stroke-miterlimit: 10;
          }
          .cls-8,
          .cls-9 {
            font-family: Barlow-Regular, Barlow;
          }
          .cls-16,
          .cls-9 {
            fill: #6f6f6e;
          }
          .cls-10 {
            letter-spacing: -0.02em;
          }
          .cls-11 {
            letter-spacing: 0em;
          }
          .cls-12 {
            letter-spacing: -0.01em;
          }
          .cls-13 {
            letter-spacing: 0em;
          }
          .cls-14 {
            letter-spacing: -0.01em;
          }
          .cls-15 {
            letter-spacing: 0em;
          }
          .cls-17 {
            stroke: #d9d9d9;
            stroke-width: 2px;
          }
          .cls-18 {
            stroke: #1c1463;
            stroke-width: 0.75px;
          }
          .cls-19,
          .cls-21 {
            fill: #231f20;
          }
          .cls-19 {
            opacity: 0.09;
          }
          .cls-20 {
            stroke: #231f20;
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke-width: 0.47px;
          }
          .cls-21 {
            opacity: 0.3;
            mix-blend-mode: multiply;
          }
          .cls-22 {
            mask: url(#mask);
          }
        </style>
        <mask
          id="mask"
          x="48.84"
          y="-8726.4"
          width="22.36"
          height="32766"
          maskUnits="userSpaceOnUse"
        />
      </defs>
      <g class="cls-1">
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_2-2" data-name="Layer 2">
            <circle class="cls-2" cx="94.39" cy="251.7" r="66.08" />
            <text class="cls-3" transform="translate(50.95 247.82)">
              <tspan x="20">35%</tspan>
              <tspan class="cls-4">
                <tspan x="-8.37" y="22">Risk</tspan>
                <tspan class="cls-5" x="33.83" y="22">f</tspan>
                <tspan x="40.95" y="22" xml:space="preserve">or MI</tspan>
              </tspan>
            </text>
            <line class="cls-6" x1="58.92" y1="236.58" x2="58.92" y2="247.86" />
            <polygon
              class="cls-7"
              points="50.19 239.13 58.92 224.02 67.64 239.13 50.19 239.13"
            />
            <text
              class="cls-8"
              transform="translate(135.38 260.24) scale(0.58)"
            >
              11,||
            </text>
            <text class="cls-9" transform="translate(180.7 240.78)">
              <tspan class="cls-10">P</tspan>
              <tspan x="11.48" y="0">er unit inc</tspan>
              <tspan class="cls-11" x="97.2" y="0">r</tspan>
              <tspan x="104.38" y="0">ease</tspan>
              <tspan class="cls-12" x="149.6" y="0">o</tspan>
              <tspan x="160.4" y="0">f</tspan>
              <tspan x="0" y="26">serum phosph</tspan>
              <tspan class="cls-13" x="122.9" y="26">a</tspan>
              <tspan class="cls-14" x="133.04" y="26">t</tspan>
              <tspan x="140.02" y="26">e</tspan>
            </text>
            <text class="cls-9" transform="translate(331.4 260.12) scale(0.58)">
              <tspan class="cls-15">1</tspan>
              <tspan x="6.94" y="0">1,&sect;</tspan>
            </text>
            <path
              class="cls-16"
              d="M22.44,21.63V8.14a.24.24,0,0,1,.26-.26h.94a.33.33,0,0,1,.3.18l3.66,5.79q.06.12.12,0L31.4,8.06a.33.33,0,0,1,.3-.18h.94a.24.24,0,0,1,.26.26V21.63a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-11c0-.09-.08-.09-.12,0l-3.16,5a.33.33,0,0,1-.3.18h-.46a.33.33,0,0,1-.3-.18l-3.16-5c0-.08-.12-.08-.12,0v11a.24.24,0,0,1-.26.26h-.9A.24.24,0,0,1,22.44,21.63Z"
            />
            <path
              class="cls-16"
              d="M35.77,25.63v-.7c0-.16.07-.26.15-.26h.14c1.5,0,1.94-.48,2.62-2.72a.13.13,0,0,0,0-.12l-3.37-9.76a.21.21,0,0,1,.22-.3h.94a.29.29,0,0,1,.3.22l2.59,7.84c0,.1.1.1.12,0L42,12a.25.25,0,0,1,.28-.22h1a.21.21,0,0,1,.22.3l-3.68,10.7c-.9,2.56-1.5,3.12-3.72,3.12h-.14C35.84,25.89,35.77,25.79,35.77,25.63Z"
            />
            <path
              class="cls-16"
              d="M45.22,19.27a8.38,8.38,0,0,1-.29-2.46,9.29,9.29,0,0,1,.26-2.44,3.89,3.89,0,0,1,4-2.76A3.84,3.84,0,0,1,53,14.35a9,9,0,0,1,.28,2.46A8.77,8.77,0,0,1,53,19.27a4.13,4.13,0,0,1-7.8,0Zm6.48-.42a9.35,9.35,0,0,0,.16-2,8.67,8.67,0,0,0-.16-2,2.68,2.68,0,0,0-5.16,0,8.89,8.89,0,0,0-.16,2,8.78,8.78,0,0,0,.16,2,2.68,2.68,0,0,0,5.16,0Z"
            />
            <path
              class="cls-16"
              d="M56.11,19.27a8.81,8.81,0,0,1-.26-2.48,9.41,9.41,0,0,1,.26-2.44,4.2,4.2,0,0,1,7.81-.16,3.89,3.89,0,0,1,.12.54.25.25,0,0,1-.24.3l-.88.1a.24.24,0,0,1-.3-.22,1,1,0,0,0,0-.24A2.52,2.52,0,0,0,60,12.85a2.46,2.46,0,0,0-2.54,1.94,8.65,8.65,0,0,0-.19,2,8.23,8.23,0,0,0,.19,2,2.67,2.67,0,0,0,5.1.16.22.22,0,0,0,0-.1l0,0a.23.23,0,0,1,.3-.22l.86.14a.25.25,0,0,1,.24.3c0,.08,0,.2-.08.34a4.18,4.18,0,0,1-7.81-.18Z"
            />
            <path
              class="cls-16"
              d="M73.86,15v6.66a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-.72c0-.08-.06-.12-.12,0a4.22,4.22,0,0,1-3.12,1.18c-1.7,0-3.31-.82-3.31-2.92s1.53-3.24,4.13-3.24h2.32a.09.09,0,0,0,.1-.1v-.74a2,2,0,0,0-2.34-2.2c-1.26,0-2.08.52-2.3,1.36a.24.24,0,0,1-.3.2l-1-.12c-.16,0-.25-.08-.24-.22.27-1.46,1.75-2.46,3.81-2.46C72.52,11.61,73.86,13,73.86,15Zm-1.42,3.68V17.11a.09.09,0,0,0-.1-.1h-2.1c-1.74,0-2.92.74-2.92,2s1,1.78,2.2,1.78C71,20.83,72.44,20.05,72.44,18.65Z"
            />
            <path
              class="cls-16"
              d="M82,11.91a.24.24,0,0,1,.14.32l-.2.88c0,.16-.14.22-.32.16a2.72,2.72,0,0,0-1-.1,2.47,2.47,0,0,0-2.4,2.62v5.84a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V12a.24.24,0,0,1,.26-.26H78a.24.24,0,0,1,.26.26v1.12c0,.1.06.12.1,0a2.88,2.88,0,0,1,2.56-1.53A2.23,2.23,0,0,1,82,11.91Z"
            />
            <path
              class="cls-16"
              d="M90.32,7.88h.9a.24.24,0,0,1,.26.26V21.63a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-.76c0-.08-.06-.1-.12,0a3.07,3.07,0,0,1-2.54,1.22,3.62,3.62,0,0,1-3.67-2.68,8.59,8.59,0,0,1-.27-2.54,9.51,9.51,0,0,1,.23-2.48,3.64,3.64,0,0,1,3.71-2.74,3.11,3.11,0,0,1,2.54,1.2c.06.08.12,0,.12,0V8.14A.24.24,0,0,1,90.32,7.88Zm-.3,9a5.71,5.71,0,0,0-.36-2.48,2.15,2.15,0,0,0-2.1-1.5,2.3,2.3,0,0,0-2.22,1.46,4.75,4.75,0,0,0-.46,2.52,5.51,5.51,0,0,0,.36,2.42,2.3,2.3,0,0,0,2.3,1.56,2.17,2.17,0,0,0,2.14-1.54A5.57,5.57,0,0,0,90,16.83Z"
            />
            <path
              class="cls-16"
              d="M94.45,8.91a1.09,1.09,0,1,1,1.09,1A1,1,0,0,1,94.45,8.91Zm.39,12.72V12a.24.24,0,0,1,.26-.26H96a.24.24,0,0,1,.26.26v9.6a.24.24,0,0,1-.26.26h-.9A.24.24,0,0,1,94.84,21.63Z"
            />
            <path
              class="cls-16"
              d="M106.86,15v6.66a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-.72c0-.08-.06-.12-.12,0a4.23,4.23,0,0,1-3.13,1.18c-1.7,0-3.3-.82-3.3-2.92s1.52-3.24,4.12-3.24h2.33a.09.09,0,0,0,.1-.1v-.74a2,2,0,0,0-2.34-2.2c-1.27,0-2.09.52-2.31,1.36a.24.24,0,0,1-.3.2l-1-.12c-.16,0-.26-.08-.24-.22.26-1.46,1.74-2.46,3.81-2.46C105.52,11.61,106.86,13,106.86,15Zm-1.42,3.68V17.11a.09.09,0,0,0-.1-.1h-2.11c-1.74,0-2.92.74-2.92,2s1,1.78,2.2,1.78C104,20.83,105.44,20.05,105.44,18.65Z"
            />
            <path
              class="cls-16"
              d="M109.79,21.63V8.14a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26V21.63a.24.24,0,0,1-.26.26h-.9A.24.24,0,0,1,109.79,21.63Z"
            />
            <path
              class="cls-16"
              d="M9.1,30.91a1,1,0,0,1,1.08-1,1,1,0,1,1,0,2.07A1,1,0,0,1,9.1,30.91Zm.38,12.72V34a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v9.6a.24.24,0,0,1-.26.26h-.9A.24.24,0,0,1,9.48,43.63Z"
            />
            <path
              class="cls-16"
              d="M21.9,37.09v6.54a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V37.37a2.32,2.32,0,0,0-2.38-2.5A2.32,2.32,0,0,0,15.64,37v6.66a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V34a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v.74c0,.08.06.14.1.06a3.15,3.15,0,0,1,2.68-1.2A3.26,3.26,0,0,1,21.9,37.09Z"
            />
            <path
              class="cls-16"
              d="M27.1,33.28v.38a.1.1,0,0,0,.1.11h2.16a.24.24,0,0,1,.26.26v.78a.24.24,0,0,1-.26.26H27.2a.09.09,0,0,0-.1.1v8.46a.24.24,0,0,1-.26.26H26a.24.24,0,0,1-.26-.26V35.17a.09.09,0,0,0-.1-.1H24.34a.24.24,0,0,1-.26-.26V34a.24.24,0,0,1,.26-.26H25.6a.1.1,0,0,0,.1-.11V33.2c0-2.38.7-3.32,3.18-3.32h.52a.24.24,0,0,1,.26.26v.73a.23.23,0,0,1-.26.25H29C27.48,31.12,27.1,31.76,27.1,33.28Z"
            />
            <path
              class="cls-16"
              d="M39,37v6.66a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-.72c0-.08-.06-.12-.12,0a4.22,4.22,0,0,1-3.12,1.18c-1.7,0-3.3-.82-3.3-2.92s1.52-3.24,4.12-3.24h2.32a.09.09,0,0,0,.1-.1v-.74a2,2,0,0,0-2.34-2.2c-1.26,0-2.08.52-2.3,1.36a.24.24,0,0,1-.3.2l-1-.12c-.16,0-.26-.08-.24-.22.26-1.46,1.74-2.46,3.8-2.46C37.7,33.61,39,35,39,37Zm-1.42,3.68V39.11a.09.09,0,0,0-.1-.1h-2.1c-1.74,0-2.92.74-2.92,2s1,1.78,2.2,1.78C36.18,42.83,37.62,42.05,37.62,40.65Z"
            />
            <path
              class="cls-16"
              d="M47.16,33.91a.24.24,0,0,1,.14.32l-.2.88c0,.16-.14.22-.32.16a2.72,2.72,0,0,0-1-.1,2.47,2.47,0,0,0-2.4,2.62v5.84a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V34a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v1.12c0,.1.06.12.1,0a2.88,2.88,0,0,1,2.56-1.53A2.23,2.23,0,0,1,47.16,33.91Z"
            />
            <path
              class="cls-16"
              d="M49.1,41.27a8.81,8.81,0,0,1-.26-2.48,9.41,9.41,0,0,1,.26-2.44A3.85,3.85,0,0,1,53,33.61a3.67,3.67,0,0,1,4,3.12.25.25,0,0,1-.24.3l-.88.1a.24.24,0,0,1-.3-.22,1,1,0,0,0,0-.24A2.52,2.52,0,0,0,53,34.85a2.46,2.46,0,0,0-2.54,1.94,9.38,9.38,0,0,0-.18,2,8.91,8.91,0,0,0,.18,2,2.67,2.67,0,0,0,5.1.16.22.22,0,0,0,0-.1l0,0a.23.23,0,0,1,.3-.22l.86.14a.25.25,0,0,1,.24.3c0,.08,0,.2-.08.34a4.17,4.17,0,0,1-7.8-.18Z"
            />
            <path
              class="cls-16"
              d="M63.84,35H61.66a.09.09,0,0,0-.1.1v5.84c0,1.3.58,1.74,1.78,1.74h.44a.24.24,0,0,1,.26.26v.7a.26.26,0,0,1-.26.28H63.1c-1.74,0-2.92-.46-2.92-2.54V35.05a.09.09,0,0,0-.1-.1H58.94a.24.24,0,0,1-.26-.26V34a.24.24,0,0,1,.26-.26h1.14a.1.1,0,0,0,.1-.11V31.42a.24.24,0,0,1,.26-.26h.86a.24.24,0,0,1,.26.26v2.24a.1.1,0,0,0,.1.11h2.18a.24.24,0,0,1,.26.26v.66A.24.24,0,0,1,63.84,35Z"
            />
            <path
              class="cls-16"
              d="M66.62,30.91a1.08,1.08,0,1,1,1.08,1A1,1,0,0,1,66.62,30.91ZM67,43.63V34a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v9.6a.24.24,0,0,1-.26.26h-.9A.24.24,0,0,1,67,43.63Z"
            />
            <path
              class="cls-16"
              d="M71.7,41.27a8.77,8.77,0,0,1-.28-2.46,9.29,9.29,0,0,1,.26-2.44,4.15,4.15,0,0,1,7.82,0,9,9,0,0,1,.28,2.46,8.77,8.77,0,0,1-.28,2.46,4.13,4.13,0,0,1-7.8,0Zm6.48-.42a9.35,9.35,0,0,0,.16-2,8.67,8.67,0,0,0-.16-2,2.68,2.68,0,0,0-5.16,0,8.89,8.89,0,0,0-.16,2,8.78,8.78,0,0,0,.16,2,2.68,2.68,0,0,0,5.16,0Z"
            />
            <path
              class="cls-16"
              d="M90.34,37.09v6.54a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V37.37a2.43,2.43,0,0,0-4.84-.4v6.66a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V34a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v.74c0,.08.06.14.1.06a3.15,3.15,0,0,1,2.68-1.2A3.26,3.26,0,0,1,90.34,37.09Z"
            />
            <path
              class="cls-16"
              d="M97.87,45.81a16.21,16.21,0,0,1-2.14-8.42,16.49,16.49,0,0,1,2.2-8.61.3.3,0,0,1,.3-.16h.84c.2,0,.28.12.19.3a18.52,18.52,0,0,0-1.91,8.45,18,18,0,0,0,1.91,8.3c.09.18,0,.3-.19.3h-.88A.35.35,0,0,1,97.87,45.81Z"
            />
            <path
              class="cls-16"
              d="M102.93,43.63V30.14a.24.24,0,0,1,.26-.26h1a.33.33,0,0,1,.29.18l3.67,5.79q.06.12.12,0l3.68-5.79a.33.33,0,0,1,.3-.18h.94a.24.24,0,0,1,.26.26V43.63a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V32.58c0-.09-.08-.09-.12,0l-3.16,5a.33.33,0,0,1-.3.18h-.46a.33.33,0,0,1-.3-.18l-3.17-5c0-.08-.12-.08-.12,0V43.63a.23.23,0,0,1-.25.26h-.91A.24.24,0,0,1,102.93,43.63Z"
            />
            <path
              class="cls-16"
              d="M117.16,43.63V30.14a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26V43.63a.24.24,0,0,1-.26.26h-.9A.24.24,0,0,1,117.16,43.63Z"
            />
            <path
              class="cls-16"
              d="M123.31,46h-.88c-.2,0-.28-.12-.17-.3a18.23,18.23,0,0,0,1.9-8.3,18.78,18.78,0,0,0-1.9-8.45c-.11-.18,0-.3.17-.3h.84a.31.31,0,0,1,.31.16,16.49,16.49,0,0,1,2.2,8.61,16.21,16.21,0,0,1-2.14,8.42A.35.35,0,0,1,123.31,46Z"
            />
            <path
              class="cls-16"
              d="M34.81,94.67,30.47,81.18a.21.21,0,0,1,.21-.3h1a.26.26,0,0,1,.28.22l3.64,11.63c0,.1.1.1.12,0L39.33,81.1a.26.26,0,0,1,.28-.22h.94a.21.21,0,0,1,.22.3L36.39,94.67a.26.26,0,0,1-.28.22h-1A.26.26,0,0,1,34.81,94.67Z"
            />
            <path
              class="cls-16"
              d="M49.43,88v6.67a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-.72c0-.08-.06-.12-.12,0a4.22,4.22,0,0,1-3.12,1.18c-1.7,0-3.3-.82-3.3-2.92s1.52-3.24,4.12-3.24h2.32a.1.1,0,0,0,.1-.11V88a2,2,0,0,0-2.34-2.2c-1.26,0-2.08.53-2.3,1.36a.25.25,0,0,1-.3.21l-1-.13c-.16,0-.26-.08-.24-.21.26-1.47,1.74-2.47,3.8-2.47C48.09,84.6,49.43,86,49.43,88ZM48,91.65V90.11a.09.09,0,0,0-.1-.1h-2.1c-1.74,0-2.92.74-2.92,2s1,1.78,2.2,1.78C46.57,93.83,48,93.05,48,91.65Z"
            />
            <path
              class="cls-16"
              d="M51.89,92.33v-.18a.24.24,0,0,1,.25-.26H53c.16,0,.26.08.26.18v.18c0,.84,1,1.64,2.4,1.64S58,93.17,58,92.23s-1.16-1.38-2.48-1.78c-1.72-.5-3.56-1.08-3.56-3,0-1.72,1.5-2.8,3.66-2.8s3.72,1.18,3.72,2.76a.25.25,0,0,1-.26.27h-.82c-.16,0-.26-.07-.26-.15v-.12c0-.88-.9-1.6-2.4-1.6-1.34,0-2.26.59-2.26,1.55s1.08,1.36,2.44,1.75c1.7.49,3.64,1,3.64,3C59.41,93.85,58,95,55.69,95S51.89,93.79,51.89,92.33Z"
            />
            <path
              class="cls-16"
              d="M61.94,92.27a8.84,8.84,0,0,1-.26-2.49,9.47,9.47,0,0,1,.26-2.44,4.19,4.19,0,0,1,7.81-.15,3.35,3.35,0,0,1,.12.54.25.25,0,0,1-.24.3l-.88.09a.24.24,0,0,1-.3-.21,1,1,0,0,0,0-.25,2.52,2.52,0,0,0-2.58-1.82,2.46,2.46,0,0,0-2.54,1.94,8.75,8.75,0,0,0-.19,2,8.23,8.23,0,0,0,.19,2,2.67,2.67,0,0,0,5.1.16.22.22,0,0,0,0-.1l0,0a.23.23,0,0,1,.3-.22l.86.14a.25.25,0,0,1,.24.3c0,.08,0,.2-.08.34a4.18,4.18,0,0,1-7.81-.18Z"
            />
            <path
              class="cls-16"
              d="M78.79,84.76h.9A.24.24,0,0,1,80,85v9.61a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-.76c0-.08-.06-.12-.12,0A3.05,3.05,0,0,1,75.76,95a3.25,3.25,0,0,1-3.52-3.3V85a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v6.29a2.27,2.27,0,0,0,2.39,2.48,2.33,2.33,0,0,0,2.48-2.48V85A.24.24,0,0,1,78.79,84.76Z"
            />
            <path
              class="cls-16"
              d="M83.13,94.63V81.14a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26V94.63a.24.24,0,0,1-.26.26h-.9A.24.24,0,0,1,83.13,94.63Z"
            />
            <path
              class="cls-16"
              d="M95.05,88v6.67a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-.72c0-.08-.06-.12-.12,0a4.22,4.22,0,0,1-3.12,1.18c-1.71,0-3.31-.82-3.31-2.92s1.52-3.24,4.13-3.24h2.32a.1.1,0,0,0,.1-.11V88a2,2,0,0,0-2.34-2.2c-1.27,0-2.08.53-2.31,1.36,0,.17-.13.22-.3.21l-1-.13c-.16,0-.26-.08-.24-.21.26-1.47,1.75-2.47,3.81-2.47C93.71,84.6,95.05,86,95.05,88Zm-1.42,3.69V90.11a.09.09,0,0,0-.1-.1h-2.1c-1.75,0-2.92.74-2.92,2s1,1.78,2.2,1.78C92.19,93.83,93.63,93.05,93.63,91.65Z"
            />
            <path
              class="cls-16"
              d="M103.17,84.9a.24.24,0,0,1,.14.32l-.2.88c0,.16-.14.22-.32.16a2.75,2.75,0,0,0-1-.1,2.48,2.48,0,0,0-2.41,2.62v5.85a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V85a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v1.12c0,.1.07.12.11,0a2.86,2.86,0,0,1,2.56-1.52A2.24,2.24,0,0,1,103.17,84.9Z"
            />
            <path
              class="cls-16"
              d="M14.74,114.27a8.84,8.84,0,0,1-.26-2.49,9.47,9.47,0,0,1,.26-2.44,3.85,3.85,0,0,1,3.88-2.74,3.9,3.9,0,0,1,3.92,2.59,3.35,3.35,0,0,1,.12.54.25.25,0,0,1-.24.3l-.88.09a.24.24,0,0,1-.3-.21,1,1,0,0,0,0-.25,2.52,2.52,0,0,0-2.58-1.82,2.46,2.46,0,0,0-2.54,1.94,9.49,9.49,0,0,0-.18,2,8.91,8.91,0,0,0,.18,2,2.45,2.45,0,0,0,2.54,2,2.47,2.47,0,0,0,2.56-1.8.22.22,0,0,0,0-.1l0,0a.23.23,0,0,1,.3-.22l.86.14a.25.25,0,0,1,.24.3c0,.08,0,.2-.08.34a3.83,3.83,0,0,1-3.92,2.6A3.84,3.84,0,0,1,14.74,114.27Z"
            />
            <path
              class="cls-16"
              d="M32.48,110v6.67a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-.72c0-.08-.06-.12-.12,0a4.22,4.22,0,0,1-3.12,1.18c-1.7,0-3.31-.82-3.31-2.92s1.53-3.24,4.13-3.24H31a.1.1,0,0,0,.1-.11V110a2,2,0,0,0-2.34-2.2c-1.26,0-2.08.53-2.3,1.36a.25.25,0,0,1-.3.21l-1-.13c-.17,0-.26-.08-.25-.21.27-1.47,1.75-2.47,3.81-2.47C31.14,106.6,32.48,108,32.48,110Zm-1.42,3.69v-1.54a.09.09,0,0,0-.1-.1h-2.1c-1.74,0-2.92.74-2.92,2s1,1.78,2.2,1.78C29.62,115.83,31.06,115.05,31.06,113.65Z"
            />
            <path
              class="cls-16"
              d="M35.42,116.63V103.14a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v13.49a.24.24,0,0,1-.26.26h-.9A.24.24,0,0,1,35.42,116.63Z"
            />
            <path
              class="cls-16"
              d="M40,114.27a8.84,8.84,0,0,1-.26-2.49,9.47,9.47,0,0,1,.26-2.44,3.85,3.85,0,0,1,3.88-2.74,3.9,3.9,0,0,1,3.92,2.59,3.35,3.35,0,0,1,.12.54.25.25,0,0,1-.24.3l-.88.09a.24.24,0,0,1-.3-.21,1,1,0,0,0,0-.25,2.52,2.52,0,0,0-2.58-1.82,2.46,2.46,0,0,0-2.54,1.94,9.49,9.49,0,0,0-.18,2,8.91,8.91,0,0,0,.18,2,2.67,2.67,0,0,0,5.1.16.22.22,0,0,0,0-.1l0,0a.23.23,0,0,1,.3-.22l.86.14a.25.25,0,0,1,.24.3c0,.08,0,.2-.08.34a3.83,3.83,0,0,1-3.92,2.6A3.84,3.84,0,0,1,40,114.27Z"
            />
            <path
              class="cls-16"
              d="M50.23,103.9a1.09,1.09,0,1,1,1.09,1A1,1,0,0,1,50.23,103.9Zm.39,12.73V107a.24.24,0,0,1,.26-.26h.9A.24.24,0,0,1,52,107v9.61a.24.24,0,0,1-.26.26h-.9A.24.24,0,0,1,50.62,116.63Z"
            />
            <path
              class="cls-16"
              d="M59.24,102.88h.52a.24.24,0,0,1,.26.26v.72a.24.24,0,0,1-.26.26h-.4c-1.52,0-1.9.64-1.9,2.16v.38a.09.09,0,0,0,.1.1h2.16A.24.24,0,0,1,60,107v.78a.24.24,0,0,1-.26.26H57.56a.09.09,0,0,0-.1.1v8.47a.24.24,0,0,1-.26.26h-.88a.24.24,0,0,1-.26-.26v-8.47a.09.09,0,0,0-.1-.1H54.7a.25.25,0,0,1-.27-.26V107a.25.25,0,0,1,.27-.26H56a.09.09,0,0,0,.1-.1v-.46C56.06,103.82,56.76,102.88,59.24,102.88Zm5.18,1a1.08,1.08,0,1,1-1.08-1A1,1,0,0,1,64.42,103.9Zm-1.78,12.73V107a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v9.61a.24.24,0,0,1-.26.26h-.9A.24.24,0,0,1,62.64,116.63Z"
            />
            <path
              class="cls-16"
              d="M67.31,114.27a8.88,8.88,0,0,1-.25-2.49,9.54,9.54,0,0,1,.25-2.44,4.19,4.19,0,0,1,7.81-.15,3.35,3.35,0,0,1,.12.54.25.25,0,0,1-.24.3l-.88.09a.24.24,0,0,1-.3-.21,1,1,0,0,0,0-.25,2.52,2.52,0,0,0-2.58-1.82,2.46,2.46,0,0,0-2.54,1.94,9.35,9.35,0,0,0-.19,2,8.76,8.76,0,0,0,.19,2,2.67,2.67,0,0,0,5.1.16.22.22,0,0,0,0-.1l0,0a.23.23,0,0,1,.3-.22l.86.14a.25.25,0,0,1,.24.3c0,.08,0,.2-.08.34a4.18,4.18,0,0,1-7.81-.18Z"
            />
            <path
              class="cls-16"
              d="M85.06,110v6.67a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-.72c0-.08-.06-.12-.12,0a4.23,4.23,0,0,1-3.13,1.18c-1.7,0-3.3-.82-3.3-2.92s1.52-3.24,4.13-3.24h2.32a.1.1,0,0,0,.1-.11V110a2,2,0,0,0-2.34-2.2c-1.27,0-2.08.53-2.31,1.36a.25.25,0,0,1-.3.21l-1-.13c-.16,0-.26-.08-.24-.21.26-1.47,1.75-2.47,3.81-2.47C83.72,106.6,85.06,108,85.06,110Zm-1.42,3.69v-1.54a.09.09,0,0,0-.1-.1H81.43c-1.74,0-2.92.74-2.92,2s1,1.78,2.21,1.78C82.2,115.83,83.64,115.05,83.64,113.65Z"
            />
            <path
              class="cls-16"
              d="M92.19,107.94H90a.09.09,0,0,0-.1.1v5.85c0,1.3.58,1.74,1.78,1.74h.45a.23.23,0,0,1,.25.26v.7a.25.25,0,0,1-.25.28h-.69c-1.74,0-2.92-.46-2.92-2.54V108a.09.09,0,0,0-.1-.1H87.29a.24.24,0,0,1-.26-.26V107a.24.24,0,0,1,.26-.26h1.14a.09.09,0,0,0,.1-.1v-2.24a.24.24,0,0,1,.26-.26h.86a.24.24,0,0,1,.26.26v2.24a.09.09,0,0,0,.1.1h2.18a.25.25,0,0,1,.27.26v.66A.25.25,0,0,1,92.19,107.94Z"
            />
            <path
              class="cls-16"
              d="M95,103.9a1.09,1.09,0,1,1,1.09,1A1,1,0,0,1,95,103.9Zm.38,12.73V107a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v9.61a.24.24,0,0,1-.26.26h-.9A.24.24,0,0,1,95.35,116.63Z"
            />
            <path
              class="cls-16"
              d="M100.06,114.27a8.38,8.38,0,0,1-.29-2.46,9.19,9.19,0,0,1,.26-2.44,3.89,3.89,0,0,1,4-2.77,3.84,3.84,0,0,1,3.88,2.74,9.08,9.08,0,0,1,.28,2.47,8.77,8.77,0,0,1-.28,2.46,4.13,4.13,0,0,1-7.8,0Zm6.48-.42a9.39,9.39,0,0,0,.16-2,8.58,8.58,0,0,0-.16-2,2.67,2.67,0,0,0-5.16,0,12.83,12.83,0,0,0,0,4,2.68,2.68,0,0,0,5.16,0Z"
            />
            <path
              class="cls-16"
              d="M118.7,110.08v6.55a.24.24,0,0,1-.27.26h-.89a.25.25,0,0,1-.27-.26v-6.26a2.43,2.43,0,0,0-4.84-.41v6.67a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V107a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v.74c0,.08.06.15.1.06a3.15,3.15,0,0,1,2.68-1.2A3.27,3.27,0,0,1,118.7,110.08Z"
            />
            <path
              class="cls-16"
              d="M283.93,21.67l-.8-2.44s0-.08-.1-.08h-6c-.06,0-.08,0-.1.08l-.78,2.44a.26.26,0,0,1-.28.22h-1a.21.21,0,0,1-.22-.3l4.4-13.49a.26.26,0,0,1,.28-.22h1.28a.26.26,0,0,1,.28.22l4.42,13.49a.21.21,0,0,1-.22.3h-1A.26.26,0,0,1,283.93,21.67ZM277.49,18h5.14c.06,0,.1,0,.08-.12l-2.6-8.18c0-.11-.1-.11-.12,0l-2.58,8.18C277.39,18,277.43,18,277.49,18Z"
            />
            <path
              class="cls-16"
              d="M292.91,11.91a.24.24,0,0,1,.14.32l-.2.88c0,.16-.14.22-.32.16a2.72,2.72,0,0,0-1-.1,2.47,2.47,0,0,0-2.4,2.62v5.84a.24.24,0,0,1-.26.26H288a.24.24,0,0,1-.26-.26V12a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v1.12c0,.1.06.12.1,0a2.88,2.88,0,0,1,2.56-1.53A2.23,2.23,0,0,1,292.91,11.91Z"
            />
            <path
              class="cls-16"
              d="M299.57,13h-2.18a.09.09,0,0,0-.1.1v5.84c0,1.3.58,1.74,1.78,1.74h.44a.24.24,0,0,1,.26.26v.7a.26.26,0,0,1-.26.28h-.68c-1.74,0-2.92-.46-2.92-2.54V13.05a.09.09,0,0,0-.1-.1h-1.14a.24.24,0,0,1-.26-.26V12a.24.24,0,0,1,.26-.26h1.14a.1.1,0,0,0,.1-.11V9.42a.24.24,0,0,1,.26-.26H297a.24.24,0,0,1,.26.26v2.24a.1.1,0,0,0,.1.11h2.18a.24.24,0,0,1,.26.26v.66A.24.24,0,0,1,299.57,13Z"
            />
            <path
              class="cls-16"
              d="M308.77,19.33a.23.23,0,0,1,.34-.12l.58.32a.23.23,0,0,1,.12.34,3.92,3.92,0,0,1-3.72,2.18,3.69,3.69,0,0,1-3.74-2.5,7.86,7.86,0,0,1-.38-2.76,9.37,9.37,0,0,1,.18-2.32A3.77,3.77,0,0,1,306,11.61a3.73,3.73,0,0,1,4,3.44,10.6,10.6,0,0,1,.12,2,.24.24,0,0,1-.26.26h-6.4a.09.09,0,0,0-.1.1,6.36,6.36,0,0,0,.12,1.46,2.6,2.6,0,0,0,2.72,2A2.75,2.75,0,0,0,308.77,19.33Zm-5.24-4.6a5.61,5.61,0,0,0-.16,1.36.09.09,0,0,0,.1.1h5.14a.09.09,0,0,0,.1-.1,8.42,8.42,0,0,0-.12-1.28,2.5,2.5,0,0,0-2.58-2A2.38,2.38,0,0,0,303.53,14.73Z"
            />
            <path
              class="cls-16"
              d="M318.13,11.91a.24.24,0,0,1,.14.32l-.2.88c0,.16-.14.22-.32.16a2.72,2.72,0,0,0-1-.1,2.47,2.47,0,0,0-2.4,2.62v5.84a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V12a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v1.12c0,.1.06.12.1,0A2.88,2.88,0,0,1,317,11.66,2.23,2.23,0,0,1,318.13,11.91Z"
            />
            <path
              class="cls-16"
              d="M320,8.91a1.08,1.08,0,1,1,1.08,1A1,1,0,0,1,320,8.91Zm.38,12.72V12a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v9.6a.24.24,0,0,1-.26.26h-.9A.24.24,0,0,1,320.39,21.63Z"
            />
            <path
              class="cls-16"
              d="M332.41,15v6.66a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-.72c0-.08-.06-.12-.12,0a4.22,4.22,0,0,1-3.12,1.18c-1.7,0-3.3-.82-3.3-2.92s1.52-3.24,4.12-3.24h2.32a.09.09,0,0,0,.1-.1v-.74a2,2,0,0,0-2.34-2.2c-1.26,0-2.08.52-2.3,1.36a.24.24,0,0,1-.3.2l-1-.12c-.16,0-.26-.08-.24-.22.26-1.46,1.74-2.46,3.8-2.46C331.07,11.61,332.41,13,332.41,15ZM331,18.65V17.11a.09.09,0,0,0-.1-.1h-2.1c-1.74,0-2.92.74-2.92,2s1,1.78,2.2,1.78C329.55,20.83,331,20.05,331,18.65Z"
            />
            <path
              class="cls-16"
              d="M335.35,21.63V8.14a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26V21.63a.24.24,0,0,1-.26.26h-.9A.24.24,0,0,1,335.35,21.63Z"
            />
            <path
              class="cls-16"
              d="M257.57,41.27a8.81,8.81,0,0,1-.26-2.48,9.41,9.41,0,0,1,.26-2.44,3.85,3.85,0,0,1,3.88-2.74,3.67,3.67,0,0,1,4,3.12.25.25,0,0,1-.24.3l-.88.1a.24.24,0,0,1-.3-.22,1,1,0,0,0,0-.24,2.52,2.52,0,0,0-2.58-1.82,2.46,2.46,0,0,0-2.54,1.94,9.38,9.38,0,0,0-.18,2,8.91,8.91,0,0,0,.18,2A2.67,2.67,0,0,0,264,41a.22.22,0,0,0,0-.1l0,0a.23.23,0,0,1,.3-.22l.86.14a.25.25,0,0,1,.24.3c0,.08,0,.2-.08.34a4.17,4.17,0,0,1-7.8-.18Z"
            />
            <path
              class="cls-16"
              d="M267.93,41.27a8.77,8.77,0,0,1-.28-2.46,9.29,9.29,0,0,1,.26-2.44,4.15,4.15,0,0,1,7.82,0,9,9,0,0,1,.28,2.46,8.77,8.77,0,0,1-.28,2.46,4.13,4.13,0,0,1-7.8,0Zm6.48-.42a9.35,9.35,0,0,0,.16-2,8.67,8.67,0,0,0-.16-2,2.68,2.68,0,0,0-5.16,0,8.89,8.89,0,0,0-.16,2,8.78,8.78,0,0,0,.16,2,2.68,2.68,0,0,0,5.16,0Z"
            />
            <path
              class="cls-16"
              d="M292.37,37v6.64a.24.24,0,0,1-.26.26h-.88a.24.24,0,0,1-.26-.26V37.27a2.32,2.32,0,1,0-4.64,0v6.4a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V37.27a2.3,2.3,0,1,0-4.6,0v6.4a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V34a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v.7c0,.08.06.12.12,0a3.21,3.21,0,0,1,2.64-1.14,3,3,0,0,1,2.88,1.6c0,.08.08.08.12,0a3.28,3.28,0,0,1,3.06-1.62A3.06,3.06,0,0,1,292.37,37Z"
            />
            <path
              class="cls-16"
              d="M303.57,38.83a9.06,9.06,0,0,1-.24,2.48,3.62,3.62,0,0,1-3.7,2.74,3.11,3.11,0,0,1-2.54-1.2c-.06-.08-.12,0-.12,0v4.62a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V34a.24.24,0,0,1,.26-.26h.9A.24.24,0,0,1,297,34v.76c0,.08.06.1.12,0a3.07,3.07,0,0,1,2.54-1.22,3.6,3.6,0,0,1,3.66,2.68A8.56,8.56,0,0,1,303.57,38.83Zm-1.42,0a5.51,5.51,0,0,0-.36-2.42,2.3,2.3,0,0,0-2.3-1.56,2.17,2.17,0,0,0-2.14,1.54,5.57,5.57,0,0,0-.34,2.44,5.71,5.71,0,0,0,.36,2.48,2.15,2.15,0,0,0,2.1,1.5,2.3,2.3,0,0,0,2.22-1.46A4.75,4.75,0,0,0,302.15,38.83Z"
            />
            <path
              class="cls-16"
              d="M306.39,43.63V30.14a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26V43.63a.24.24,0,0,1-.26.26h-.9A.24.24,0,0,1,306.39,43.63Z"
            />
            <path
              class="cls-16"
              d="M310.81,30.91a1.08,1.08,0,1,1,1.08,1A1,1,0,0,1,310.81,30.91Zm.38,12.72V34a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v9.6a.24.24,0,0,1-.26.26h-.9A.24.24,0,0,1,311.19,43.63Z"
            />
            <path
              class="cls-16"
              d="M323.21,37v6.66a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-.72c0-.08-.06-.12-.12,0a4.22,4.22,0,0,1-3.12,1.18c-1.7,0-3.3-.82-3.3-2.92s1.52-3.24,4.12-3.24h2.32a.09.09,0,0,0,.1-.1v-.74a2,2,0,0,0-2.34-2.2c-1.26,0-2.08.52-2.3,1.36a.24.24,0,0,1-.3.2l-1-.12c-.16,0-.26-.08-.24-.22.26-1.46,1.74-2.46,3.8-2.46C321.87,33.61,323.21,35,323.21,37Zm-1.42,3.68V39.11a.09.09,0,0,0-.1-.1h-2.1c-1.74,0-2.92.74-2.92,2s1,1.78,2.2,1.78C320.35,42.83,321.79,42.05,321.79,40.65Z"
            />
            <path
              class="cls-16"
              d="M333.83,37.09v6.54a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V37.37a2.43,2.43,0,0,0-4.84-.4v6.66a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V34a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v.74c0,.08.06.14.1.06a3.15,3.15,0,0,1,2.68-1.2A3.26,3.26,0,0,1,333.83,37.09Z"
            />
            <path
              class="cls-16"
              d="M336.87,41.27a8.81,8.81,0,0,1-.26-2.48,9.41,9.41,0,0,1,.26-2.44,3.85,3.85,0,0,1,3.88-2.74,3.67,3.67,0,0,1,4,3.12.25.25,0,0,1-.24.3l-.88.1a.24.24,0,0,1-.3-.22,1,1,0,0,0,0-.24,2.52,2.52,0,0,0-2.58-1.82,2.46,2.46,0,0,0-2.54,1.94,9.38,9.38,0,0,0-.18,2,8.91,8.91,0,0,0,.18,2,2.67,2.67,0,0,0,5.1.16.22.22,0,0,0,0-.1l0,0a.23.23,0,0,1,.3-.22l.86.14a.25.25,0,0,1,.24.3c0,.08,0,.2-.08.34a4.17,4.17,0,0,1-7.8-.18Z"
            />
            <path
              class="cls-16"
              d="M353.77,41.33a.23.23,0,0,1,.34-.12l.58.32a.23.23,0,0,1,.12.34,3.92,3.92,0,0,1-3.72,2.18,3.69,3.69,0,0,1-3.74-2.5,7.86,7.86,0,0,1-.38-2.76,9.37,9.37,0,0,1,.18-2.32A3.77,3.77,0,0,1,351,33.61a3.73,3.73,0,0,1,4,3.44,10.6,10.6,0,0,1,.12,2,.24.24,0,0,1-.26.26h-6.4a.09.09,0,0,0-.1.1,6.36,6.36,0,0,0,.12,1.46,2.6,2.6,0,0,0,2.72,2A2.75,2.75,0,0,0,353.77,41.33Zm-5.24-4.6a5.61,5.61,0,0,0-.16,1.36.09.09,0,0,0,.1.1h5.14a.09.09,0,0,0,.1-.1,8.42,8.42,0,0,0-.12-1.28,2.5,2.5,0,0,0-2.58-2A2.38,2.38,0,0,0,348.53,36.73Z"
            />
            <path
              class="cls-16"
              d="M241.25,94.63V81.14a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26V93.55a.09.09,0,0,0,.1.1h7a.24.24,0,0,1,.26.26v.72a.24.24,0,0,1-.26.26h-8.24A.24.24,0,0,1,241.25,94.63Z"
            />
            <path
              class="cls-16"
              d="M258.83,92.33a.23.23,0,0,1,.34-.12l.58.32a.23.23,0,0,1,.12.34,3.92,3.92,0,0,1-3.72,2.18,3.69,3.69,0,0,1-3.74-2.5,7.88,7.88,0,0,1-.38-2.77,9.41,9.41,0,0,1,.18-2.32,3.77,3.77,0,0,1,3.86-2.86,3.73,3.73,0,0,1,4,3.44,10.72,10.72,0,0,1,.12,2,.24.24,0,0,1-.26.26h-6.4a.09.09,0,0,0-.1.1,6.36,6.36,0,0,0,.12,1.46,2.6,2.6,0,0,0,2.72,2A2.75,2.75,0,0,0,258.83,92.33Zm-5.24-4.6a5.47,5.47,0,0,0-.16,1.36.09.09,0,0,0,.1.1h5.14a.09.09,0,0,0,.1-.1,8.15,8.15,0,0,0-.12-1.28,2.5,2.5,0,0,0-2.58-2A2.38,2.38,0,0,0,253.59,87.73Z"
            />
            <path
              class="cls-16"
              d="M265,84.28v.38a.09.09,0,0,0,.1.1h2.16a.24.24,0,0,1,.26.26v.78a.24.24,0,0,1-.26.26h-2.16a.09.09,0,0,0-.1.1v8.47a.24.24,0,0,1-.26.26h-.88a.24.24,0,0,1-.26-.26V86.16a.09.09,0,0,0-.1-.1h-1.26a.24.24,0,0,1-.26-.26V85a.24.24,0,0,1,.26-.26h1.26a.09.09,0,0,0,.1-.1V84.2c0-2.38.7-3.32,3.18-3.32h.52a.24.24,0,0,1,.26.26v.72a.24.24,0,0,1-.26.26h-.4C265.35,82.12,265,82.76,265,84.28Z"
            />
            <path
              class="cls-16"
              d="M274.27,85.94h-2.18a.09.09,0,0,0-.1.1v5.85c0,1.3.58,1.74,1.78,1.74h.44a.24.24,0,0,1,.26.26v.7a.26.26,0,0,1-.26.28h-.68c-1.74,0-2.92-.46-2.92-2.54V86a.09.09,0,0,0-.1-.1h-1.14a.24.24,0,0,1-.26-.26V85a.24.24,0,0,1,.26-.26h1.14a.09.09,0,0,0,.1-.1V82.42a.24.24,0,0,1,.26-.26h.86a.24.24,0,0,1,.26.26v2.24a.09.09,0,0,0,.1.1h2.18a.24.24,0,0,1,.26.26v.66A.24.24,0,0,1,274.27,85.94Z"
            />
            <path
              class="cls-16"
              d="M283.59,94.67l-3.24-9.61a.21.21,0,0,1,.22-.3h1a.26.26,0,0,1,.28.22l2.5,7.79c0,.1.1.1.12,0L287,85a.26.26,0,0,1,.28-.22l1,0c.18,0,.26.12.2.3l-3.22,9.59a.3.3,0,0,1-.3.22h-1.08A.3.3,0,0,1,283.59,94.67Z"
            />
            <path
              class="cls-16"
              d="M296.93,92.33a.23.23,0,0,1,.34-.12l.58.32a.23.23,0,0,1,.12.34,3.92,3.92,0,0,1-3.72,2.18,3.69,3.69,0,0,1-3.74-2.5,7.88,7.88,0,0,1-.38-2.77,9.41,9.41,0,0,1,.18-2.32,3.77,3.77,0,0,1,3.86-2.86,3.73,3.73,0,0,1,4,3.44,10.72,10.72,0,0,1,.12,2,.24.24,0,0,1-.26.26h-6.4a.09.09,0,0,0-.1.1,6.36,6.36,0,0,0,.12,1.46,2.6,2.6,0,0,0,2.72,2A2.75,2.75,0,0,0,296.93,92.33Zm-5.24-4.6a5.47,5.47,0,0,0-.16,1.36.09.09,0,0,0,.1.1h5.14a.09.09,0,0,0,.1-.1,8.15,8.15,0,0,0-.12-1.28,2.5,2.5,0,0,0-2.58-2A2.38,2.38,0,0,0,291.69,87.73Z"
            />
            <path
              class="cls-16"
              d="M308.79,88.08v6.55a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V88.37a2.43,2.43,0,0,0-4.84-.41v6.67a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V85a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v.74c0,.08.06.15.1.06a3.15,3.15,0,0,1,2.68-1.2A3.26,3.26,0,0,1,308.79,88.08Z"
            />
            <path
              class="cls-16"
              d="M316.17,85.94H314a.09.09,0,0,0-.1.1v5.85c0,1.3.58,1.74,1.78,1.74h.44a.24.24,0,0,1,.26.26v.7a.26.26,0,0,1-.26.28h-.68c-1.74,0-2.92-.46-2.92-2.54V86a.09.09,0,0,0-.1-.1h-1.14a.24.24,0,0,1-.26-.26V85a.24.24,0,0,1,.26-.26h1.14a.09.09,0,0,0,.1-.1V82.42a.24.24,0,0,1,.26-.26h.86a.24.24,0,0,1,.26.26v2.24a.09.09,0,0,0,.1.1h2.18a.24.24,0,0,1,.26.26v.66A.24.24,0,0,1,316.17,85.94Z"
            />
            <path
              class="cls-16"
              d="M324.35,84.9a.24.24,0,0,1,.14.32l-.2.88c0,.16-.14.22-.32.16a2.72,2.72,0,0,0-1-.1,2.47,2.47,0,0,0-2.4,2.62v5.85a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V85a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v1.12c0,.1.06.12.1,0a2.87,2.87,0,0,1,2.56-1.52A2.24,2.24,0,0,1,324.35,84.9Z"
            />
            <path
              class="cls-16"
              d="M326.23,81.9a1.08,1.08,0,1,1,1.08,1A1,1,0,0,1,326.23,81.9Zm.38,12.73V85a.24.24,0,0,1,.26-.26h.9A.24.24,0,0,1,328,85v9.61a.24.24,0,0,1-.26.26h-.9A.24.24,0,0,1,326.61,94.63Z"
            />
            <path
              class="cls-16"
              d="M331.29,92.27a8.84,8.84,0,0,1-.26-2.49,9.47,9.47,0,0,1,.26-2.44,3.85,3.85,0,0,1,3.88-2.74,3.9,3.9,0,0,1,3.92,2.59,3.35,3.35,0,0,1,.12.54.25.25,0,0,1-.24.3l-.88.09a.24.24,0,0,1-.3-.21,1,1,0,0,0,0-.25,2.52,2.52,0,0,0-2.58-1.82,2.46,2.46,0,0,0-2.54,1.94,9.49,9.49,0,0,0-.18,2,8.91,8.91,0,0,0,.18,2,2.67,2.67,0,0,0,5.1.16.22.22,0,0,0,0-.1l0,0a.23.23,0,0,1,.3-.22l.86.14a.25.25,0,0,1,.24.3c0,.08,0,.2-.08.34a4.17,4.17,0,0,1-7.8-.18Z"
            />
            <path
              class="cls-16"
              d="M348.13,84.76h.9a.24.24,0,0,1,.26.26v9.61a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-.76c0-.08-.06-.12-.12,0a3,3,0,0,1-2.64,1.2,3.25,3.25,0,0,1-3.52-3.3V85a.24.24,0,0,1,.26-.26h.9A.24.24,0,0,1,343,85v6.29a2.26,2.26,0,0,0,2.38,2.48,2.33,2.33,0,0,0,2.48-2.48V85A.24.24,0,0,1,348.13,84.76Z"
            />
            <path
              class="cls-16"
              d="M352.47,94.63V81.14a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26V94.63a.24.24,0,0,1-.26.26h-.9A.24.24,0,0,1,352.47,94.63Z"
            />
            <path
              class="cls-16"
              d="M364.39,88v6.67a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-.72c0-.08-.06-.12-.12,0a4.22,4.22,0,0,1-3.12,1.18c-1.7,0-3.3-.82-3.3-2.92s1.52-3.24,4.12-3.24h2.32a.1.1,0,0,0,.1-.11V88a2,2,0,0,0-2.34-2.2c-1.26,0-2.08.53-2.3,1.36a.25.25,0,0,1-.3.21l-1-.13c-.16,0-.26-.08-.24-.21.26-1.47,1.74-2.47,3.8-2.47C363.05,84.6,364.39,86,364.39,88ZM363,91.65V90.11a.09.09,0,0,0-.1-.1h-2.1c-1.74,0-2.92.74-2.92,2s1,1.78,2.2,1.78C361.53,93.83,363,93.05,363,91.65Z"
            />
            <path
              class="cls-16"
              d="M372.51,84.9a.24.24,0,0,1,.14.32l-.2.88c0,.16-.14.22-.32.16a2.72,2.72,0,0,0-1-.1,2.47,2.47,0,0,0-2.4,2.62v5.85a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V85a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v1.12c0,.1.06.12.1,0a2.87,2.87,0,0,1,2.56-1.52A2.24,2.24,0,0,1,372.51,84.9Z"
            />
            <path
              class="cls-16"
              d="M298.4,110v6.64a.24.24,0,0,1-.26.26h-.88a.24.24,0,0,1-.26-.26v-6.36a2.32,2.32,0,1,0-4.64,0v6.4a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-6.36a2.3,2.3,0,1,0-4.6,0v6.4a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26V107a.24.24,0,0,1,.26-.26h.9a.24.24,0,0,1,.26.26v.7c0,.08.06.12.12,0a3.21,3.21,0,0,1,2.64-1.14,3,3,0,0,1,2.88,1.6c0,.08.08.08.12,0a3.28,3.28,0,0,1,3.06-1.62A3.06,3.06,0,0,1,298.4,110Z"
            />
            <path
              class="cls-16"
              d="M308.74,110v6.67a.24.24,0,0,1-.26.26h-.9a.24.24,0,0,1-.26-.26v-.72c0-.08-.06-.12-.12,0a4.22,4.22,0,0,1-3.12,1.18c-1.7,0-3.3-.82-3.3-2.92s1.52-3.24,4.12-3.24h2.32a.1.1,0,0,0,.1-.11V110a2,2,0,0,0-2.34-2.2c-1.26,0-2.08.53-2.3,1.36a.25.25,0,0,1-.3.21l-1-.13c-.16,0-.26-.08-.24-.21.26-1.47,1.74-2.47,3.8-2.47C307.4,106.6,308.74,108,308.74,110Zm-1.42,3.69v-1.54a.09.09,0,0,0-.1-.1h-2.1c-1.74,0-2.92.74-2.92,2s1,1.78,2.2,1.78C305.88,115.83,307.32,115.05,307.32,113.65Z"
            />
            <path
              class="cls-16"
              d="M311.2,114.33v-.18a.24.24,0,0,1,.26-.26h.86c.16,0,.26.08.26.18v.18c0,.84,1,1.64,2.4,1.64s2.32-.72,2.32-1.66-1.16-1.38-2.48-1.78c-1.72-.5-3.56-1.08-3.56-3,0-1.72,1.5-2.8,3.66-2.8s3.72,1.18,3.72,2.76a.25.25,0,0,1-.26.27h-.82c-.16,0-.26-.07-.26-.15v-.12c0-.88-.9-1.6-2.4-1.6-1.34,0-2.26.59-2.26,1.55s1.08,1.36,2.44,1.75c1.7.49,3.64,1,3.64,3,0,1.72-1.46,2.86-3.72,2.86S311.2,115.79,311.2,114.33Z"
            />
            <path
              class="cls-16"
              d="M320.54,114.33v-.18a.24.24,0,0,1,.26-.26h.86c.16,0,.26.08.26.18v.18c0,.84,1,1.64,2.4,1.64s2.32-.72,2.32-1.66-1.16-1.38-2.48-1.78c-1.72-.5-3.56-1.08-3.56-3,0-1.72,1.5-2.8,3.66-2.8s3.72,1.18,3.72,2.76a.25.25,0,0,1-.26.27h-.82c-.16,0-.26-.07-.26-.15v-.12c0-.88-.9-1.6-2.4-1.6-1.34,0-2.26.59-2.26,1.55s1.08,1.36,2.44,1.75c1.7.49,3.64,1,3.64,3,0,1.72-1.46,2.86-3.72,2.86S320.54,115.79,320.54,114.33Z"
            />
            <line class="cls-17" y1="168.18" x2="395.3" y2="168.18" />
            <line class="cls-18" x1="6.77" y1="52.52" x2="159.32" y2="52.52" />
            <path
              class="cls-19"
              d="M219.7,76.08l-.7-6.91A24.47,24.47,0,0,0,215.92,60a3.72,3.72,0,0,0,2.84.31,4,4,0,0,0,2.34-4.8c-.62-2.12-3.23-2.12-3.23-2.12a3.84,3.84,0,0,0,.37-3.79,3.43,3.43,0,0,0-3.44-2,11,11,0,0,0,2.12-3,5.15,5.15,0,0,0-1-5.81l-2.62-1a22.19,22.19,0,0,0,.9-7.78c-.94-7.9-3.56-6.42-4.36-8.4s1.1-4.77,1.1-4.77l4.89-5.83a3.31,3.31,0,0,0-2.67-2.22s-3.71,4.19-5.38,6-3.56,4.26-3.88,3.05a4.94,4.94,0,0,1,.11-2.49l4.61-8.93c-1.06-1.88-4.5-1.61-4.5-1.61s-5.46,7.65-6.32,8.65-3.27,1.44-3.27,1.44a28.25,28.25,0,0,1-5-.88,2.09,2.09,0,0,1-1.17-2.44l-.05-11a3.93,3.93,0,0,0-3.83.27l-.28,5.33c-.82,7.29-2.88,9.37-2.88,9.37l-3.16,1.5a5.79,5.79,0,0,0-1.42-4.67A3.4,3.4,0,0,0,173,11l-3.41,2.81c-1.56-.76-3.06-3.22-3.06-3.22C164.05,7.11,161,1.94,161,1.94a17.92,17.92,0,0,0-5.49,3,6.71,6.71,0,0,0-2.66,5.35c1.69,1.81,7.64,13,7.64,13,4.58,10.65,2.37,18.26,1.48,22.2s-6.11,13.92-6.11,13.92a57.78,57.78,0,0,0-6.08,15.7c-1.78,8.49,1.62,14,1.62,14L150.46,93c-3.58,12.37,3.67,18.33,8.2,23.36s20.26,15.26,23.5,16.94,5.83,6.78,14.21-.88,14.08-17,18.36-25.06,6.49-27.32,6.59-29.51S219.7,76.08,219.7,76.08Zm-36-46.27c1.56-2.07,4.64-2,4.64-2,9.68-1,13.54,4,13.54,4L203.4,34C191.11,29.88,183.68,29.81,183.68,29.81Z"
            />
            <path
              class="cls-20"
              d="M178.14,17.1l3.16-1.5s2.06-2.08,2.88-9.37L184.46.9a3.93,3.93,0,0,1,3.83-.27l.05,11a2.09,2.09,0,0,0,1.17,2.44,28.25,28.25,0,0,0,5,.88s2.41-.43,3.27-1.44,6.32-8.65,6.32-8.65,3.44-.27,4.5,1.61L204,15.38a4.94,4.94,0,0,0-.11,2.49c.32,1.21,2.21-1.24,3.88-3.05s5.38-6,5.38-6a3.31,3.31,0,0,1,2.67,2.22l-4.89,5.83s-1.9,2.78-1.1,4.77,3.42.5,4.36,8.4a22.19,22.19,0,0,1-.9,7.78l2.62,1a5.15,5.15,0,0,1,1,5.81,11,11,0,0,1-2.12,3,3.43,3.43,0,0,1,3.44,2,3.84,3.84,0,0,1-.37,3.79s2.61,0,3.23,2.12a4,4,0,0,1-2.34,4.8,3.72,3.72,0,0,1-2.84-.31A24.47,24.47,0,0,1,219,69.17l.7,6.91s1.71-.4,1.62,1.78-2.31,21.47-6.59,29.51-10,17.4-18.36,25.06-11,2.55-14.21.88-19-11.91-23.5-16.94-11.78-11-8.2-23.36l.94-3.92s-3.4-5.49-1.62-14a57.78,57.78,0,0,1,6.08-15.7s5.22-10,6.11-13.92,3.1-11.55-1.48-22.2c0,0-6-11.19-7.64-13a6.71,6.71,0,0,1,2.66-5.35,17.92,17.92,0,0,1,5.49-3s3.05,5.17,5.48,8.69c0,0,1.5,2.46,3.06,3.22L173,11a3.4,3.4,0,0,1,3.77,1.39A5.79,5.79,0,0,1,178.14,17.1Z"
            />
            <path
              class="cls-21"
              d="M174,12.29a2.42,2.42,0,0,1,1.81,1,4.73,4.73,0,0,1,.84,2.07,3.21,3.21,0,0,1,0,1.51,1.38,1.38,0,0,1-1,1,1.65,1.65,0,0,1-1.35-.63,5.13,5.13,0,0,1-1.34-2.92,2.37,2.37,0,0,1,.19-1.42C173.34,12.5,173.49,12.29,174,12.29Z"
            />
            <path
              class="cls-21"
              d="M214.68,40a2.31,2.31,0,0,0-.72-.19,4.67,4.67,0,0,0-2.64.57A6,6,0,0,0,209,43a5.34,5.34,0,0,0-.72,2.85,2.78,2.78,0,0,0,1.55,2.37,3.32,3.32,0,0,0,2.79-.3c2.15-1.11,3.78-4,3.15-6.43A2.09,2.09,0,0,0,214.68,40Z"
            />
            <path
              class="cls-21"
              d="M216.13,49.17A1.27,1.27,0,0,0,215,49a2.9,2.9,0,0,0-1.06.6,4.18,4.18,0,0,0-1.18,1.35,2.84,2.84,0,0,0-.3,1.9,2,2,0,0,0,1.66,1.58,2.43,2.43,0,0,0,2-1,3.55,3.55,0,0,0,.8-2.32A2.77,2.77,0,0,0,216.13,49.17Z"
            />
            <path
              class="cls-21"
              d="M219.44,54.87a1.26,1.26,0,0,0-1.08-.17,2.9,2.9,0,0,0-1,.55,4.13,4.13,0,0,0-1.12,1.26,2.57,2.57,0,0,0-.29,1.76,1.85,1.85,0,0,0,1.59,1.46,2.33,2.33,0,0,0,1.91-.94,3.33,3.33,0,0,0,.77-2.15A2.55,2.55,0,0,0,219.44,54.87Z"
            />
            <path
              class="cls-21"
              d="M175.79,47.91s-4.43-4.8-5.93-10.08-1.48-8.16,1.47-12.83,8.56-6.38,8.56-6.38a6,6,0,0,0,2.87-2.25C184,14.63,186,5.54,184.43,1.42c0,0-.28,11.45-3.13,14.18L179,16.79a5.39,5.39,0,0,0-2.08,1.85h0s-9.77,4.84-10.3,13.69S174.56,49,174.56,49l1.23-1.06"
            />
            <path
              class="cls-21"
              d="M187.18.27l-.54,14.29s-.87.87,2,1.41,6.89,1.13,8.12.47,4.4-6.16,4.82-6.38,2.51-5.22,2.51-5.22l-6.61,8.9a7.29,7.29,0,0,1-4.53,1c-.32,0-3.47-.71-3.47-.71s-1.16.14-1.17-3.48L188.29.63Z"
            />
            <path
              class="cls-21"
              d="M208.28,6a42.7,42.7,0,0,1-2.77,4.61c-2.15,1.81-3.31,5.16-3.82,7.78a1.31,1.31,0,0,0,0,.34.73.73,0,0,0,.15.32,2.12,2.12,0,0,0,1.74.54h1.23a1.79,1.79,0,0,0,.65-.08c.82-.3,1.76-2.19,2.29-2.89s1-1.35,1.52-2L213.68,9l-.55-.14L206.72,16l-2.6,2.21a2.35,2.35,0,0,1-.14-2.8l3.24-6.27,1.37-2.66Z"
            />
            <path
              class="cls-21"
              d="M215.39,10.16s-3.8,4.47-4.45,5.27-2.66,4.19-2.66,4.19-1.2,1.47-.61,2.34a22.5,22.5,0,0,0,2.25,2.39,8.08,8.08,0,0,1,2.48,5.46A45.58,45.58,0,0,1,211.09,37l2.18.87s1.88-5.77.5-10.24S210,22,210,22s-1.43-1.68.34-4.12,4.72-6,4.72-6l.74-.88Z"
            />
            <path
              class="cls-21"
              d="M187.48,30.12s-2.51,7.26-1.32,11h0l-.86.34s-3.15-3.67-3.12-6.5a9.74,9.74,0,0,1,1.56-5l3.74.12"
            />
            <path
              class="cls-21"
              d="M153.39,7.67l9.43,14.26s3.08,3,1.87,15.9S160.35,56,157.77,60.25s-7.11,20.16-4.64,24.06a55.7,55.7,0,0,0,.7,13.39c1.27,7.18,6.14,14.71,9.26,18.15s21.78,15.48,21.93,15.6,3.75,2.47,9-1,18-20.92,19.65-24.82S221.35,81,220.16,76.2c0,0,1.37.28,1.16,2.08s-1.71,13-2.7,17-2.72,9.86-3.79,11.86-7.85,13-7.85,13l-10.34,12.15s-6.35,7.15-11.65,2.88h0l-10.92-6.94s-9.08-6.14-13.6-10.12-9-9-10.19-14a26.58,26.58,0,0,1,0-10.27l.95-5.13s-2.28-4.18-2.08-7.69a42.92,42.92,0,0,1,1.24-8.52c.56-1.91,4-10.47,4-10.47s2.4-5,4.13-8.11A37,37,0,0,0,163,40.46c.5-5.26.41-9.64-1.69-15.14a90.23,90.23,0,0,0-5.45-10.23l-3-4.8A7.18,7.18,0,0,1,153.39,7.67Z"
            />
            <path
              class="cls-21"
              d="M173.07,15.09s1.22-1,3.56.3h0s-.43-2.83-2.65-3.1-.91,2.8-.91,2.8"
            />
            <path
              class="cls-21"
              d="M209.24,42.57l6.28,2s1-3-.27-4.11-4.37-.26-6,2.11"
            />
            <path
              class="cls-21"
              d="M212.58,51.32l3.53,2.07s1.81-3,0-4.22c-1.41-.94-3,1.25-3,1.25Z"
            />
            <path
              class="cls-21"
              d="M216.22,56.51l3.21,2.28s1.59-2.41,0-3.92-3.22,1.64-3.22,1.64"
            />
            <path
              class="cls-21"
              d="M182.14,43.07s-7.37-8.89-2.85-14.32A13.66,13.66,0,0,1,189.67,24a19.46,19.46,0,0,1,6,1,20.78,20.78,0,0,1,5.46,2.37,12.82,12.82,0,0,1,3.68,3.87,16.58,16.58,0,0,1,1.72,3.93L203.4,34s-2.36-5.8-11.52-6.26h0s-6.8-.83-8.79,2.88h0s-3.33,5,2.41,10.59l-3.36,1.83"
            />
            <path
              class="cls-21"
              d="M158.4,3.06l8.51,13.73,2.63-2.94s-.46.48-5.21-6.48L161,1.94Z"
            />
            <path
              class="cls-21"
              d="M191.58,41.8s-2.64-1-2.88-1.38,2.39.15,2.39.15l16,3.9a1,1,0,0,1,.41.89,6.32,6.32,0,0,0,.28,1.89c.6,1.53,1.64,1.67,1.64,1.67Z"
            />
            <path
              class="cls-21"
              d="M213,54.73s.63,1.07,3.19-.08c0,0-1.76,2.11-1.26,3.42h0L213,54.73"
            />
            <path
              class="cls-21"
              d="M209.45,49.26a6.22,6.22,0,0,0,3.44-.34S211,51,211.42,52.46Z"
            />
            <path
              class="cls-21"
              d="M198.53,130.09a.11.11,0,0,1,.15.16,25.51,25.51,0,0,1-4.3,3.94c-1.79,1.31-4,2.59-6.19,2.34-1.95-.22-3.68-1.69-5.35-2.72A200.84,200.84,0,0,1,165.22,122c-5.23-4.07-11.49-10-13.89-15.3a19,19,0,0,1-1.75-5.39c-.7-4.7,1.22-11.32,2.63-15.79,2.09-6.61,5.61-12.68,9.1-18.67-2.63,7.63-5.23,15.39-5.68,23.44s1.49,16.58,7,22.52c4.29,4.67,10.29,7.33,15.45,11,3.24,2.32,6.23,5.1,9.9,6.67C191.22,131.93,195.77,132,198.53,130.09Z"
            />
            <path
              class="cls-21"
              d="M171.91,21.35a16.62,16.62,0,0,0-4.34,21c1.21,2.22,3,4.36,3,6.89s-2.09,4.82-3.9,6.79a73.89,73.89,0,0,0-13.91,21.8c-.28.69-.66,1.48-1.39,1.64a1.59,1.59,0,0,1-1.69-1.17,4.6,4.6,0,0,1,0-2.24,17.68,17.68,0,0,0,1.45,12.43A117.84,117.84,0,0,1,174.56,49a17.56,17.56,0,0,1-1.16-28.25A9.27,9.27,0,0,0,171.91,21.35Z"
            />
            <path
              class="cls-21"
              d="M192.49,53.59a36.91,36.91,0,0,0-6.56,8.4c-1.62,3.18-2.28,7-1,10.34,1.51,3.74,5.36,6.18,9.33,6.92s8.07,0,12-1,7.77-2.32,11.77-2.83a3,3,0,0,1,2.39.43c-4.54.79-8.86,2.52-13.27,3.85s-9.09,2.27-13.62,1.42-8.9-3.81-10.31-8.21c-1.15-3.59-.17-7.59,1.75-10.84S189.7,56.23,192.49,53.59Z"
            />
            <path
              class="cls-21"
              d="M217.65,64.33a83.51,83.51,0,0,0-7.3-10.51c-1.54-1.89-3.27-3.78-5.58-4.53a9.18,9.18,0,0,0-5.65.18A27,27,0,0,0,194,52a23.5,23.5,0,0,1,7.34-3.66c2.42-.6,5.45-.65,7.56.62a1.53,1.53,0,0,1,.57.46c1,1.56,2.09,2.81,3,4.33C214.49,57.15,216.59,60.66,217.65,64.33Z"
            />
            <path
              class="cls-21"
              d="M205.51,34.71a11.89,11.89,0,0,0-5.15-6.44,18.71,18.71,0,0,0-8-2.56,15.11,15.11,0,0,0-6.17.45,8.34,8.34,0,0,0-4.83,3.69c-1.61,2.85-1,6.44.17,9.51a4.53,4.53,0,0,0,1.5,2.3,1.7,1.7,0,0,0,2.42-.42,11.76,11.76,0,0,1-3.29-5.17,6.69,6.69,0,0,1,1-5.89,6.91,6.91,0,0,1,4-2.27,15.49,15.49,0,0,1,4.66-.14c3.62.3,7.48,1.2,9.87,3.94C202.88,33,203.85,34.8,205.51,34.71Z"
            />
            <path
              class="cls-21"
              d="M190.18,30.5A21.61,21.61,0,0,0,186.52,41l-1.22.48s-5.87-6-1.6-11.9Z"
            />
            <path
              class="cls-20"
              d="M174,12.29a2.42,2.42,0,0,1,1.81,1,4.73,4.73,0,0,1,.84,2.07,3.21,3.21,0,0,1,0,1.51,1.38,1.38,0,0,1-1,1,1.65,1.65,0,0,1-1.35-.63,5.13,5.13,0,0,1-1.34-2.92,2.37,2.37,0,0,1,.19-1.42C173.34,12.5,173.49,12.29,174,12.29Z"
            />
            <path
              class="cls-20"
              d="M174.29,49.22a30.46,30.46,0,0,1-6.4-9.24,15.27,15.27,0,0,1-.49-11A18.22,18.22,0,0,1,169,25.31a20.18,20.18,0,0,1,6.17-5.53c1.27-.77,2.66-1.41,3.07-3"
            />
            <path
              class="cls-20"
              d="M203.4,34a10.53,10.53,0,0,0-5-4.67,20.29,20.29,0,0,0-6.74-1.67c-2.61-.25-5.5-.14-7.46,1.6a6.84,6.84,0,0,0-1.88,6.32,12.06,12.06,0,0,0,3,5.89"
            />
            <path
              class="cls-20"
              d="M188.32,40.46c-8.16,2.18-14.43,8.66-19.51,15.41A109.89,109.89,0,0,0,151.4,89.09"
            />
            <path
              class="cls-20"
              d="M209.42,49.22c-3.75-2.13-8.59-1.49-12.35.61s-6.65,5.46-9.3,8.86a29.29,29.29,0,0,0-4.16,6.59,11.18,11.18,0,0,0-.57,7.63,11.91,11.91,0,0,0,5.83,6.36,19.72,19.72,0,0,0,11.61,2.33c6.72-.74,12.7-4.9,19.42-5.61"
            />
            <path class="cls-20" d="M213.27,37.83c-9.77-3.93-19-7.5-29.53-8" />
            <path
              class="cls-20"
              d="M214.68,40a2.31,2.31,0,0,0-.72-.19,4.67,4.67,0,0,0-2.64.57A6,6,0,0,0,209,43a5.34,5.34,0,0,0-.72,2.85,2.78,2.78,0,0,0,1.55,2.37,3.32,3.32,0,0,0,2.79-.3c2.15-1.11,3.78-4,3.15-6.43A2.09,2.09,0,0,0,214.68,40Z"
            />
            <path
              class="cls-20"
              d="M216.13,49.17A1.27,1.27,0,0,0,215,49a2.9,2.9,0,0,0-1.06.6,4.18,4.18,0,0,0-1.18,1.35,2.84,2.84,0,0,0-.3,1.9,2,2,0,0,0,1.66,1.58,2.43,2.43,0,0,0,2-1,3.55,3.55,0,0,0,.8-2.32A2.77,2.77,0,0,0,216.13,49.17Z"
            />
            <path
              class="cls-20"
              d="M219.44,54.87a1.26,1.26,0,0,0-1.08-.17,2.9,2.9,0,0,0-1,.55,4.13,4.13,0,0,0-1.12,1.26,2.57,2.57,0,0,0-.29,1.76,1.85,1.85,0,0,0,1.59,1.46,2.33,2.33,0,0,0,1.91-.94,3.33,3.33,0,0,0,.77-2.15A2.55,2.55,0,0,0,219.44,54.87Z"
            />
            <path class="cls-20" d="M209.42,49.22a5.68,5.68,0,0,0,5.44-1.67" />
            <path
              class="cls-20"
              d="M215.92,60c-2.33-4.28-3.53-5.86-6.68-10.86"
            />
            <line
              class="cls-18"
              x1="16.78"
              y1="125.68"
              x2="188.32"
              y2="125.68"
            />
            <line
              class="cls-18"
              x1="201.66"
              y1="52.52"
              x2="356.61"
              y2="52.52"
            />
            <line
              class="cls-18"
              x1="203.07"
              y1="125.68"
              x2="369.22"
              y2="125.68"
            />
            <g class="cls-22">
              <rect
                class="cls-16"
                x="48.84"
                y="224.02"
                width="22.36"
                height="27.68"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>`;
  }
}

customElements.define("disease-glass-state", DiseaseGlass);
